<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item>财务管理</el-breadcrumb-item>
            <el-breadcrumb-item>代缴查询</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search-box">
            <el-form :inline="true" :model="formFilter" class="demo-form-inline">
                <el-form-item label="结算时间">
                    <el-date-picker
                        v-model="formFilter.daterange"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="formFilter.idcard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onFilter">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="content-box">
            <div class="table" style="padding-top: 15px;">
                <el-table
                    :data="records"
                    :border="true"
                    :stripe="true"
                >
                    <el-table-column
                        prop="confirm_settlement_time"
                        align="center"
                        label="结算时间">
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        align="center"
                        label="所属项目">
                    </el-table-column>
                    <el-table-column
                        prop="sub_no"
                        align="center"
                        label="服务编号">
                    </el-table-column>
                    <el-table-column
                        prop="member_name"
                        align="center"
                        label="服务人员">
                    </el-table-column>
                    <el-table-column
                        prop="idcard"
                        align="center"
                        label="身份证号">
                    </el-table-column>
                    <el-table-column
                        prop="tax"
                        align="center"
                        label="代缴个税">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="150">
                        <template slot-scope="scope">
                            <el-button type="text" size="medium" @click="goPage(`/index/project/serviceinfo?id=${scope.row.id}&sub_id=${scope.row.sub_id}`)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination" v-if="total_page > 1">
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :page-size="20"
                        @current-change="onPageChange"
                        :page-count="total_page">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'Index',
    inject: ['back', 'goPage', 'tel'],
    data () {
        return {
            types: ['充值', '批量付款', '服务费', '代征个税'],
            formFilter: {
                daterange: [],
                start_time: '',
                end_time: '',
                idcard: ''
            },
            records: [],
            total_page: 1
        }
    },
    mounted () {
        this.getCapital()
    },
    methods: {
        getCapital (page = 1) {
            this.$http.get('/api/user/account/financial', {
                params: {
                    type: 0,
                    page,
                    size: 20,
                    start_time: this.formFilter.start_time,
                    end_time: this.formFilter.end_time,
                    idcard: this.formFilter.idcard
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.records = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        onFilter () {
            this.formFilter.start_time = this.getDateFromRange(this.formFilter.daterange)[0]
            this.formFilter.end_time = this.getDateFromRange(this.formFilter.daterange)[1]
            this.getCapital(1)
        },
        onPageChange (e) {
            this.getCapital(e)
        },
        getDateFromRange (d) {
            let daterange = !d ? [] : d
            let date0 = !(daterange[0] === '' || !daterange[0]) ? `${daterange[0].getFullYear()}-${daterange[0].getMonth() + 1}-${daterange[0].getDate()}` : ''
            let date1 = !(daterange[1] === '' || !daterange[1]) ? `${daterange[1].getFullYear()}-${daterange[1].getMonth() + 1}-${daterange[1].getDate()}` : ''
            return [date0, date1]
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
    .data-overview {
        height: 78px;
    }
</style>
